import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ar from './ar.json';
import bn from './bn.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import hi from './hi.json';
import id from './id.json';
import ja from './ja.json';
import ko from './ko.json';
import pt from './pt.json';
import ru from './ru.json';
import ur from './ur.json';
import zh from './zh.json';

export const SUPPORTED_LANGUAGES = [
  'ar', 'bn', 'de', 'en', 'es', 'fr', 'hi', 'id', 'ja', 'ko', 'pt', 'ru', 'ur', 'zh',
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const RTL_LANGUAGES: ReadonlyArray<SupportedLanguage> = ['ar', 'ur'];

export function isRtl(lng: string | undefined | null): boolean {
  if (!lng) return false;
  const base = lng.split('-')[0];
  return (RTL_LANGUAGES as readonly string[]).includes(base);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      bn: { translation: bn },
      de: { translation: de },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      hi: { translation: hi },
      id: { translation: id },
      ja: { translation: ja },
      ko: { translation: ko },
      pt: { translation: pt },
      ru: { translation: ru },
      ur: { translation: ur },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    returnObjects: false,
  });

function applyDocumentLocale(lng: string) {
  const html = document.documentElement;
  html.lang = lng;
  html.dir = isRtl(lng) ? 'rtl' : 'ltr';
}

i18n.on('languageChanged', (lng) => {
  applyDocumentLocale(lng);
});
applyDocumentLocale(i18n.language || 'en');

export default i18n;
